/**
 * Platform default palette — keep aligned with themes/services.py DEFAULT_THEME.
 * Mutable type (not `as const`) so resolveThemeTokens can merge API overrides.
 */
export interface ThemePaletteColors {
  primary: string;
  primaryForeground: string;
  secondary: string;
  background: string;
  foreground: string;
  card: string;
  cardForeground: string;
  muted: string;
  mutedForeground: string;
  success: string;
  warning: string;
  danger: string;
  border: string;
}

export const themeColors: Record<"light" | "dark" | "personal", ThemePaletteColors> = {
  light: {
    primary: "#FFD700",
    primaryForeground: "#1A1A1A",
    secondary: "#06D6A0",
    background: "#F8F9FA",
    foreground: "#1A1A1A",
    card: "#FFFFFF",
    cardForeground: "#1A1A1A",
    muted: "#F9FAFB",
    mutedForeground: "#6B7280",
    success: "#16A34A",
    warning: "#D97706",
    danger: "#DC2626",
    border: "#E5E7EB",
  },
  dark: {
    primary: "#FFD700",
    primaryForeground: "#1A1A1A",
    secondary: "#06D6A0",
    background: "#0B0F19",
    foreground: "#F8FAFC",
    card: "#111827",
    cardForeground: "#F8FAFC",
    muted: "#1F2937",
    mutedForeground: "#9CA3AF",
    success: "#16A34A",
    warning: "#D97706",
    danger: "#DC2626",
    border: "#1F2937",
  },
  personal: {
    primary: "#FFD700",
    primaryForeground: "#1A1A1A",
    secondary: "#06D6A0",
    background: "#F8F9FA",
    foreground: "#1A1A1A",
    card: "#FFFFFF",
    cardForeground: "#1A1A1A",
    muted: "#F9FAFB",
    mutedForeground: "#6B7280",
    success: "#16A34A",
    warning: "#D97706",
    danger: "#DC2626",
    border: "#E5E7EB",
  },
};
